import { useState } from 'react';

import theme from '@styles/theme';
import { possessedEquipmentHeader } from '@lib/data';
import { EQUIPMENT_DATA } from '@lib/DUMMY';

import {
    Wrapper,
    RegularFont,
    Underline
} from '@components/styled/StyledComponents';
import {
    TableWrapper,
    TableBody,
    EmptyTable
} from '@components/share/Table/table.style';
import TableHeader from '@components/share/Table/TableHeader';
import Headline from '@components/layout/Headline';
import FilterButtons from '@components/layout/FilterButtons';
import PossessionTableRow from '@components/features/Equipment/PossessionTableRow';
import Loader from '@components/share/Loader';

const Equipment = () => {
    const [loading, setLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(0);

    const totalLength = EQUIPMENT_DATA.length;

    return (
        <Wrapper>
            <Headline title="내 보유 장비 현황" />
            <FilterButtons
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                options={[
                    { title: '전체', value: 0 },
                    { title: '신형(DID)', value: 1 },
                    { title: '구형(DID)', value: 2 },
                    { title: 'LG사이니지', value: 3 }
                ]}
            />
            <TableWrapper>
                <TableHeader
                    header={possessedEquipmentHeader}
                    fontColor={theme.colors.blackColor}
                    LAST_CELL
                />
                <TableBody $minHeight={200}>
                    {loading && <Loader />}
                    {totalLength === 0 ? (
                        <EmptyTable>보유 장비가 존재하지 않습니다.</EmptyTable>
                    ) : (
                        EQUIPMENT_DATA.map((data, idx) => (
                            <PossessionTableRow
                                key={`${idx}-account-list`}
                                header={possessedEquipmentHeader}
                                data={data}
                            />
                        ))
                    )}
                </TableBody>
            </TableWrapper>
            <RegularFont
                $margin="12px 0 0"
                $fontColor={theme.colors.deepGrayFontColor}
            >
                자세한 상담 및 계약 문의는{' '}
                <Underline
                    onClick={() => window.open('https://showdoc.co.kr/service')}
                >
                    서비스 신청 페이지
                </Underline>
                를 참고해주세요.
            </RegularFont>
        </Wrapper>
    );
};

export default Equipment;
